export function normalizeEmail(email: string): string {
	return email.trim().toLowerCase();
}

export function isValidEmail(email: string): boolean {
	const normalized = normalizeEmail(email);
	if (!normalized || normalized.length > 254) {
		return false;
	}
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized);
}

export function isValidRegistrationPassword(password: string): boolean {
	if (password.length < 8) {
		return false;
	}
	if (!/[a-zA-Z]/.test(password)) {
		return false;
	}
	if (!/[0-9]/.test(password) && !/[^a-zA-Z0-9]/.test(password)) {
		return false;
	}
	return true;
}
